import { isMobile } from "./helpers";

$(".vi-select").select2({
  width: "100%",
  minimumResultsForSearch: -1,
  placeholder: function () {
    $(this).attr("data-placeholder");
  },
  language: {
    noResults: function () {
      return "Нет данных";
    },
  },
});

function collapse(block) {
  const $this = block;
  $this.find(".js-collapse-box").each((i, el) => {
    const head = $(el).find(".js-collapse-box-head");
    head.on("click", function () {
      const _this = $(this);
      _this
        .parent()
        .siblings()
        .find(".js-collapse-box-head")
        .removeClass("js-active");
      _this.parent().siblings().find(".js-collapse-box-body").slideUp(300);
      if (_this.hasClass("js-active")) {
        _this.removeClass("js-active");
        _this
          .siblings(".js-collapse-box-body")
          .slideUp(300)
          .removeClass("js-active");
      } else {
        _this.addClass("js-active");
        _this
          .siblings(".js-collapse-box-body")
          .slideDown(300)
          .addClass("js-active");
      }
    });
  });
}

collapse($(".js-collapse"));

function countdown(target) {
  const second = 1000;
  const minute = second * 60;
  const hour = minute * 60;
  const day = hour * 24;

  const countDown = new Date(target).getTime(),
    x = setInterval(function () {
      const now = new Date().getTime();
      const distance = countDown - now;
      const days = Math.floor(distance / day);
      const hours = Math.floor((distance % day) / hour);
      const minutes = Math.floor((distance % hour) / minute);
      const seconds = Math.floor((distance % minute) / second);

      const dElement = document.getElementById("days");
      const hElement = document.getElementById("hours");
      const mElement = document.getElementById("minutes");
      const sElement = document.getElementById("seconds");
      if (dElement) {
        dElement.innerText = days;
      }
      if (hElement) {
        hElement.innerText = hours;
      }
      if (mElement) {
        mElement.innerText = minutes;
      }
      if (sElement) {
        sElement.innerText = seconds;
      }

      //do something later when date is reached
      if (distance < 0) {
        document.getElementById("countdown").style.display = "none";
        clearInterval(x);
      }
    }, 0);
}

if (window.countdownEvent) {
  countdown(window.countdownEvent);
}
